/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Person, UpsertPersonStatus, DeletePersonStatus } from '../../gql-types.generated';
import { RootState } from '../../store';

interface SliceState {
  error?: Error;
  userList: Person[];
  upsertPersonStatus?: UpsertPersonStatus;
  deletePersonStatus?: DeletePersonStatus;
}

const initialState: SliceState = {
  error: undefined,
  userList: [],
  upsertPersonStatus: undefined,
  deletePersonStatus: undefined,
};

export const slice = createSlice({
  name: 'apteanAdminUsers',
  initialState,
  reducers: {
    fetchError: (state, action: PayloadAction<Error>) => {
      state.error = action.payload;
    },
    clearError: state => {
      state.error = undefined;
    },
    fetchApteanAdminUsersSuccess: (state, action: PayloadAction<Person[]>) => {
      state.userList = action.payload;
    },
    captureUpsertPersonStatus: (state, action: PayloadAction<UpsertPersonStatus | undefined>) => {
      state.upsertPersonStatus = action.payload;
    },
    captureDeletePersonStatus: (state, action: PayloadAction<DeletePersonStatus | undefined>) => {
      state.deletePersonStatus = action.payload;
    },
  },
});

export const selectApteanAdminUsers = (state: RootState): Person[] => state.apteanAdminUsers.userList;
export const selectApteanAdminUsersError = (state: RootState): Error | undefined => state.apteanAdminUsers.error;
export const selectUpsertPersonStatus = (state: RootState): UpsertPersonStatus | undefined =>
  state.apteanAdminUsers.upsertPersonStatus;
export const selectDeletePersonStatus = (state: RootState): DeletePersonStatus | undefined =>
  state.apteanAdminUsers.deletePersonStatus;

export const { fetchError, clearError, fetchApteanAdminUsersSuccess, captureUpsertPersonStatus, captureDeletePersonStatus } =
  slice.actions;

export default slice.reducer;
